import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=bc41e53a&scoped=true"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc41e53a",
  null
  
)

export default component.exports